import hsk from "../data/charactersList.json";
import { HskEntry } from "./types";

const incrementalCoverageByOrder = new Map<number, number>();

(hsk as HskEntry[]).forEach((entry, index) => {
  const previousCumulative = index > 0 ? (hsk as HskEntry[])[index - 1].freqPerc : 0;
  incrementalCoverageByOrder.set(entry.order, entry.freqPerc - previousCumulative);
});

export const getCorpusCoveragePercent = (orders: Iterable<number>): number => {
  let total = 0;
  for (const order of orders) {
    total += incrementalCoverageByOrder.get(order) ?? 0;
  }
  return total;
};

export const getCorrectAnswerCoveragePercent = (
  answeredList: { order: number; answer: boolean | null }[]
): number => {
  const correctOrders = answeredList.filter((entry) => entry.answer === true).map((entry) => entry.order);
  return getCorpusCoveragePercent(correctOrders);
};
